<div class="tag-editor">
    <input type="hidden" [id]="id" [name]="name" [required]="required" ([ngModel])="value">

    <div
        #editor
        class="tag-editor-editor"
        [attr.placeholder]="placeholder"
        [attr.contenteditable]="!disabled"
        [ngClass]="{ 'tag-editor-editor--empty': value.length === 0, 'tag-editor-editor--disabled': disabled }"
        (blur)="onBlur($event)"
        (paste)="onPaste($event)"
        (keydown.enter)="onEnter($event)"
        (keyup)="onInput($event)"
        [style.height]="rows * 1.9 + 'em'">
    </div>

    <div class="tag-editor-buttons" *ngIf="!hideButtons">
        <button *ngFor="let tag of available" type="button" [disabled]="disabled" (click)="onInsert($event, tag)">{{ 'shared.tags.' + tag | translate }}</button>
    </div>

    <!-- <h4>Value</h4>
    <pre>{{ value | json  }}</pre>

    <h4>Content</h4>
    <pre>{{ content | json  }}</pre> -->
</div>
